import { connect } from 'react-redux'
import at from 'lodash/at'
import get from 'lodash/get'

import { loadHistoriesForIssue } from '../../actions/issue-histories'

import IssueHistoriesList from '../../components/issue-histories/issue-histories-list'

function mapStateToProps (state, ownProps) {
  const pagination = get(state, `pagination.historiesByIssue.${ownProps.issue.id}`, {})
  const histories = at(state.issueHistories, pagination.ids || [])

  return {
    histories,
    hasNextPage: pagination.nextPageUrl
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(loadHistoriesForIssue(ownProps.issue.id))

  return {
    onLoadNextPage () {
      dispatch(loadHistoriesForIssue(ownProps.issue.id, true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueHistoriesList)



// WEBPACK FOOTER //
// ./src/containers/issue-histories/issue-histories-list-container.js